import React, { Fragment, useState, useEffect, useContext } from "react";
import { Form, FormGroup, Input, Label, Button } from "reactstrap";
import { Btn, H5 } from "../../../AbstractElements";
import { NamaPengguna, Password, SignIn } from "../../../Constant";
import { useNavigate } from "react-router-dom";
import { Jwt_token } from "../../../Config/Config";
import man from "../../../assets/images/dashboard/1.png";
import { handleResponse } from "../../../Services/Fack.Backend";
import FormHeader from "./FormHeader";
import logo from "../../../assets/images/logo/ui-en.png";
import AuthContext from "../../../Context/AuthContext";
import ReCAPTCHA from "react-google-recaptcha";

const LoginTab = () => {
  const { authTokens, loginUser } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    if (captcha !== "") {
    loginUser(username, password);
    }
  };

  return (
    <Fragment>
      <Form className="theme-form login-form" onSubmit={handleLogin}>
        <a href="/" className="logo">
          <img src={logo} alt="" />
        </a>
        <FormHeader />
        <FormGroup>
          <Label className="col-form-label">Username</Label>
          <Input
            className="form-control"
            type="text"
            id="username"
            placeholder="Masukkan Username Pengguna"
            onChange={(e) => setUsername(e.target.value)}
          />
        </FormGroup>
        <FormGroup className="position-relative">
          <Label className="col-form-label">Password</Label>
          <Input
            className="form-control"
            type="password"
            id="password"
            placeholder="Masukan Password Pengguna"
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormGroup>
        <div className="d-flex justify-content-center mb-3">
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
            onChange={(value) => {
              setCaptcha(value);
            }}
          />
        </div>
        {/* <Button>Sign In</Button> */}
        <Button disabled={captcha === ""}>Sign In</Button>
      </Form>
    </Fragment>
  );
};

export default LoginTab;
